import * as d3 from 'd3'

export default {

  methods: {

    event_Link(selection, col, idx) {

      if (!col.filter) return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
          d3.select(this).transition().duration(50).style('opacity', .5)
        })
        .on('mouseout', function() {
          d3.select(this).transition().duration(50).style('opacity', 1)
        })
        .on('click', () => {
          this.link_Action(this.filters[col.filter], this.rawData[idx])
        })
    },

    link_Action(filter_, data_) {

      let dataSource = {}

      Object.keys(this.keys).forEach(d=>{
        dataSource = {...dataSource, [d]: data_[this.keys[d]]}
      })
      let filterString_ = filter_ || ''

      console.log(dataSource, filterString_)

      // seting request_ from A/G jsonProps
      let request_ = this.getRequestColumnProps('request', dataSource, this.ColumnProps)
      if(!request_) return

      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // Combine filterStrings
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: {
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,
        },
        filterChain: { 
          type: request_.filterChain?.type || '', 
          target: request_.filterChain?.target || '' 
        },
        // filterChain: { 
        //   type: 'direct', 
        //   target: 'append-filter-string' 
        // },
      }
      this.$emit('request-action', request_)
    },

  } 
}